module.exports = __webpack_public_path__ + "img/global.b49d4942.svg";